<div class="table-header">
  <span>Users</span>
  <!-- <div class="table-filter">
    <form class="form-inline short">
      <select id="" class="table-filter-search form-control" disabled>
        <option></option>
        <option></option>
        <option></option>
      </select>
    </form>
  </div> -->
  <div class="position-relative table-icon action">
    <i class="fa fa-list transition text-tooltip" aria-hidden="true" title-popup="List"></i>
    <div class="tooltip-actions width-120">
      <div class="arrow-up"></div>
      <ul>
        <li>
          <label col-id="0" table-name="admin-users-list" class="checked">Username</label>
        </li>
        <li>
          <label col-id="1" table-name="admin-users-list" class="checked">Affiliation</label>
        </li>
        <li>
          <label col-id="2" table-name="admin-users-list" class="checked">First Name</label>
        </li>
        <li>
          <label col-id="3" table-name="admin-users-list" class="checked">Last Name</label>
        </li>
        <li>
          <label col-id="4" table-name="admin-users-list" class="checked">Admin</label>
        </li>
        <li>
          <label col-id="5" table-name="admin-users-list" class="checked">E-mail</label>
        </li>
        <li>
          <label col-id="6" table-name="admin-users-list" class="checked">Phone</label>
        </li>
      </ul>
    </div>
  </div>
</div>
<div class="table-panel">
  <table class="table table-striped" id="admin-users-list">
    <thead>
      <tr>
        <th>Username</th>
        <th>Affiliation</th>
        <th>First Name</th>
        <th>Last Name</th>
        <th>Admin</th>
        <th>E-mail</th>
        <th>Phone</th>

        <!--Impersonate Column-->
        <!--<th></th>-->
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let item of list | paginate: configPagerAdminUsers">
        <td>{{item.username}}</td>
        <td>{{item.affiliation}}</td>
        <td>{{item.firstName}}</td>
        <td>{{item.lastName}}</td>
        <td><i *ngIf="item.isAdmin == 'true'" class="fa fa-check-circle fa-2x" aria-hidden="true"></i></td>
        <td>{{item.email}}</td>
        <td>{{item.phone}}</td>

        <!--Impersonate popover Column-->
          <!--<td>-->
            <!--<popover-content #actionsPopup-->
                         <!--placement="left"-->
                         <!--[animation]="true"-->
                         <!--[closeOnClickOutside]="true" >-->
            <!--<p class="popup-text">Impersonate</p>-->
            <!--</popover-content>-->

            <!--<button class="view-detail-btn" [popover]="actionsPopup">...</button>-->
          <!--</td>-->
      </tr>
    </tbody>
  </table>
</div>
<app-pagination-custom [config]="configPagerAdminUsers"></app-pagination-custom>
